{
  "ts": 1749571268,
  "tsCommit": 1749476952,
  "repoName": "NCApp3",
  "branchName": "prod",
  "rev": "8bd8910",
  "ver": "20250610_1601_NCApp3_prod_8bd8910",
  "env": "production",
  "appVer": "5.5.1",
  "isBranchDeployment": false,
  "e2eApiHostUrl": "https://api-master.naturalcycles.com"
}
